import { useState } from 'react'
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import { Link } from 'react-router-dom'
import { Input } from '../../components/input'
import { InputWrapper } from '../../components/input/input.style'
import { AuthFormWrapper } from '../../container/authFormwarapper'
import { Heading, FormContainer, ButtonContainer, StyledLink } from '../../styles/auth'
import { Button } from '../../components/button'

//Login schema
const schema = yup.object().shape({
    email: yup.string().email().required("Email field is a required field"),
    password: yup.string().required("Password is a required field"),
});


const Login = () => {
    const [isLoading, setIsLoading] = useState(false);
    const {
        handleSubmit,
        register,
        formState: { errors },
        watch,
    } = useForm({ resolver: yupResolver(schema), mode: "onChange" });
    // const formData = JSON.stringify(watch());

    const onSubmit = values => {
        console.log(values)
    }
    return (
        <AuthFormWrapper>
            <FormContainer>
                <Link to="/">Go home</Link>
                <Heading>Log in</Heading>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <InputWrapper>
                        <Input
                            id="emailAddress"
                            label="email address"
                            type="email"
                            placeholder="Email address"
                            fullWidth
                            {...register("email")}
                            error={errors.email?.message}
                        />
                    </InputWrapper>
                    <InputWrapper>
                        <Input
                            endAdornment
                            id="password"
                            label="password"
                            type="password"
                            placeholder="Password"
                            fullWidth
                            {...register("password")}
                            error={errors.password?.message}
                        />
                    </InputWrapper>
                    <InputWrapper>
                        <StyledLink to="/forgot-password">FORGOT PASSWORD?</StyledLink>
                    </InputWrapper>
                    <ButtonContainer>
                        <Button
                            type="submit"
                            disabled={
                                Object.keys(errors).length > 0 ||
                                Object.values(watch()).length < 1 ||
                                isLoading
                            }
                            variant="primary"
                            isLoading={isLoading}
                            responsive
                        >
                            Log in
                        </Button>
                        <Link to='/register'>
                            <Button
                                style={{ marginLeft: '20px' }}
                                variant="secondary"
                                responsive
                            >
                                create account

                            </Button>
                        </Link>
                    </ButtonContainer>

                </form>
            </FormContainer>
        </AuthFormWrapper>
    )
}

export default Login
